<template>
  <div class="target-info"
       @click="closeMoreInfo">
    <div class="device-type"
         v-if="subReports">
      <ul v-if="reportType !== 'share'">
        <li v-for="device in subReports"
            :key="`device-${device.ReportDatum.deviceType}`"
            :class="{ active: reportDatum.deviceType === device.ReportDatum.deviceType }">
          <router-link :to="{ name: reportType === 'saved' ? 'Report' : 'TempReport', params: { id: device.id } }">
            <i :class="`icon icon--device-${deviceType(device.ReportDatum.deviceType).toLowerCase()} ${reportDatum.deviceType === device.ReportDatum.deviceType ? 'on' : 'off'}`"></i>
            {{deviceType(device.ReportDatum.deviceType)}}
            <template v-if="reportDatum.deviceType === device.ReportDatum.deviceType && !points">
              <span class="score"
                    :class="[passFail]">
                {{ passFail }}
              </span>
              <span class="jira"
                    v-if="companyType === 'SAMSUNG' && passFail === 'pass'">
                <i class="icon icon--info"></i>
                <span class="tooltip">
                  <span class="text">
                    <strong>JIRA request required</strong>
                    Please make a Jira(WAQA) ticket with <br>the shared link of this passed report.
                    <a href="https://op-jra.samsung.com/"
                       target="_blank"
                       @click="openJira">
                      https://op-jra.samsung.com/ <i class="icon icon--link"></i>
                    </a>
                  </span>
                </span>
              </span>
            </template>
          </router-link>
        </li>
      </ul>
      <ul v-else>
        <li v-for="device in subReports"
            :key="`device-${device.ReportDatum.deviceType}`"
            :class="{ active: reportDatum.deviceType === device.ReportDatum.deviceType }">
          <router-link :to="{ name: 'SharedReportWithDevice', params: { token: $route.params.token, deviceType: device.ReportDatum.deviceType } }">
            <i :class="`icon icon--device-${deviceType(device.ReportDatum.deviceType).toLowerCase()} ${reportDatum.deviceType === device.ReportDatum.deviceType ? 'on' : 'off'}`"></i>
            {{deviceType(device.ReportDatum.deviceType)}}
            <span class="score"
                  v-if="reportDatum.deviceType === device.ReportDatum.deviceType && !points"
                  :class="[passFail]">
              {{ passFail }}
            </span>
          </router-link>
        </li>
      </ul>
      <template v-if="points">
        <span class="score-all">
          <span class="score"
                :class="[allPass]">
            {{ allPass }}
          </span>
          <span class="jira"
                v-if="companyType === 'SAMSUNG' && allPass === 'pass'">
            <i class="icon icon--info"></i>
            <span class="tooltip">
              <span class="text">
                <strong>JIRA request required</strong>
                Please make a Jira(WAQA) ticket with <br>the shared link of this passed report.
                <a href="https://op-jra.samsung.com/"
                   target="_blank"
                   @click="openJira">
                  https://op-jra.samsung.com/ <i class="icon icon--link"></i>
                </a>
              </span>
            </span>
          </span>
        </span>
      </template>
    </div>
    <div class="device-type"
         v-else>
      <ul>
        <li class="active">
          <a href="#">
            <i :class="`icon icon--device-${deviceType(reportDatum.deviceType).toLowerCase()} on`"></i>
            {{deviceType(reportDatum.deviceType)}}
          </a>
        </li>
      </ul>
    </div>
    <div class="report-info">
      <div class="title">
        <h2>
          <span class="diagnosis-type">
            {{report.diagnosisType}}
          </span>
          {{ title }}
        </h2>
        <div class="type">
          <a :href="url"
             target="_blank"
             :title="`${url} : ${$t('common.openNewWindow')}`">
            <span class="report-type"
                  v-if="reportDatum.deviceType > 10">File</span>
            <span class="report-type"
                  v-else>URL</span>
            {{ reportDatum.url }}
          </a>
        </div>
      </div>
      <div class="more-info">
        <p>
          Run Date : <em>{{ report.runAt | yymmddhhmm }}</em>
        </p>
        <p>
          {{ $t('report.loginInfo') }} :
            {{ reportDatum.requireLogin ? '' : $t('report.notAvailable') }}
            <button type="button" v-if="reportDatum.requireLogin"
                    @click.stop="isShowLoginInfo = true">more</button>
          <span class="bar"></span>
          {{ $t('report.excludeElements') }} :
          {{ reportDatum.useExcludeSelectors ? '' : $t('report.notAvailable') }}
          <button type="button" v-if="reportDatum.useExcludeSelectors"
                  @click.stop="isShowSelectorsInfo = true">more</button>
          <span class="bar"></span>
          {{ $t('report.includeElements') }} :
          {{ reportDatum.useIncludeSelectors ? '' : $t('report.all') }}
          <button type="button" v-if="reportDatum.useIncludeSelectors"
                  @click.stop="isShowIncludeInfo = true">more</button>
        </p>
      </div>

      <div class="buttons">
        {{report.hideAction}}
        <template v-if="!report.hideAction">
          <template v-if="reportType === 'saved'">
            <button type="button"
                    class="btn1"
                    @click="onShareClick">
              <i class="icon icon--share"></i>
              Share
            </button>
            <button type="button"
                    class="btn2"
                    @click="onDocumentViewClick">
              <span><i :class="`icon icon--device-${deviceType(reportDatum.deviceType).toLowerCase()} on`"></i> {{deviceType(reportDatum.deviceType)}}</span>
              Document View
            </button>
            <button type="button"
                    class="btn3"
                    @click="onRemoveClick">
              Delete
            </button>
          </template>
          <button v-else-if="reportType === 'temp'"
                  type="button"
                  class="btn2"
                  @click="onSaveClick">SAVE</button>
        </template>
        <template v-if="reportType === 'share'" class="viewMode">
          <button type="button"
                  class="btn1"
                  @click="onShowReadOnlyInfoToggle">Shared</button>
<!--          <template v-if="isShowReadOnlyInfo && !userData">-->
<!--            <i18n path="sharedReport.readOnlyMessage" tag="span">-->
<!--              <br />-->
<!--              <router-link :to="{ name: 'SignIn' }">{{ $t('sharedReport.signIn') }}</router-link>-->
<!--            </i18n>-->
<!--          </template>-->
        </template>
      </div>

      <div v-if="isShowSelectorsInfo || isShowIncludeInfo || isShowLoginInfo"
           class="more-layer layer-modal"
           @click.stop>
        <div class="toast">
          <table>
            <tr v-if="isShowLoginInfo && reportDatum.requireLogin">
              <th><p>{{ $t('report.loginInfo') }}</p></th>
              <td>
                <p>URL : {{ reportDatum.loginUrl }}</p>
                <p>ID : {{ reportDatum.loginId }} / {{ reportDatum.loginIdSelector }}</p>
                <p>PW : ******** / {{ reportDatum.loginPasswordSelector }}</p>
                <p>Submit : {{ reportDatum.loginButtonSelector }}</p>
              </td>
            </tr>
            <tr v-if="isShowSelectorsInfo && reportDatum.useExcludeSelectors">
              <th><p>{{ $t('report.excludeElements') }}<br>Selector</p></th>
              <td>
                <p v-for="(selector, index) in reportDatum.excludeSelectors.split('\n')"
                   :key="index">{{ selector }}</p>
              </td>
            </tr>
            <tr v-if="isShowIncludeInfo && reportDatum.useIncludeSelectors">
              <th><p>{{ $t('report.includeElements') }}<br>Selector</p></th>
              <td>
                <p v-for="(selector, index) in reportDatum.includeSelectors.split('\n')"
                   :key="index">{{ selector }}</p>
              </td>
            </tr>
          </table>
          <button type="button" class="btn_3" @click="closeMoreInfo">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { deviceType, companyType } from '@/lib/utils'

export default {
  name: 'DiagnosisReportInfo',
  props: ['report', 'shareData', 'reportType', 'scoreData', 'summaryMap'],
  data () {
    return {
      isShowReadOnlyInfo: false,
      isShowSelectorsInfo: false,
      isShowIncludeInfo: false,
      isShowLoginInfo: false,
      cutoff: 100
    }
  },
  computed: {
    ...mapGetters(['userData']),
    subReports () {
      return this.report.subReports || this.shareData.subReports || []
    },
    points () {
      let result = []
      for (const subReport of this.subReports) {
        if (subReport.criticalRule) {
          const point = 100 - Math.floor(subReport.criticalErrorRule / subReport.criticalRule * 100)
          result.push(point)
        }
      }
      if (!result.length) {
        return false
      }
      return result
    },
    companyType () {
      return companyType
    },
    allPass () {
      if (this.points) {
        for (const point of this.points) {
          if (point < this.cutoff) {
            return 'fail'
          }
        }
        return 'pass'
      }
      return 'fail'
    },
    point () {
      if (this.scoreData.criticalRule) {
        return 100 - Math.floor(this.scoreData.criticalErrorRule / this.scoreData.criticalRule * 100)
      } else {
        return 100
      }
    },
    passFail () {
      if (this.point >= this.cutoff) {
        return 'pass'
      }
      return 'fail'
    },
    reportDatum () {
      return this.report.ReportDatum
    },
    title () {
      return this.reportDatum.title || 'Unsaved Report'
    },
    url () {
      if (this.reportDatum.deviceType < 10) {
        return this.reportDatum.url
      } else {
        return this.report.fileUrl
      }
    }
  },
  methods: {
    openJira () {
      window.open('https://op-jra.samsung.com/')
    },
    deviceType (code) {
      return deviceType.get(code).key
    },
    onShareClick () {
      this.$emit('onShareClick')
    },
    onSaveClick () {
      this.$emit('onSaveClick')
    },
    onRemoveClick () {
      this.$emit('onRemoveClick')
    },
    onShowReadOnlyInfoToggle () {
      this.isShowReadOnlyInfo = !this.isShowReadOnlyInfo
    },
    closeMoreInfo () {
      this.isShowSelectorsInfo = false
      this.isShowIncludeInfo = false
      this.isShowLoginInfo = false
    },
    onDocumentViewClick () {
      this.$emit('onDocumentViewClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.target-info {
  height: 131px;

  .device-type {
    margin: 9px -9px 0;
    padding: 0 9px 9px 19px;
    border-bottom: 1px solid #d3d3ce;

    ul {
      display: inline-block;
      height: 47px;
      border-radius: 10px;
      box-shadow: inset 0 2px 6px 0 rgba(0, 0, 0, 0.5);
      background-color: #333333;

      li {
        display: inline-block;
        height: 47px;
        border-radius: 10px;
        font-size: 18px;
        font-weight: bold;
        line-height: 1;
        color: #b6b6ad;

        a {
          display: inline-block;
          padding: 10px 12px 10px 13px;
          height: 47px;
          box-sizing: border-box;
        }

        i {
          margin-right: 5px;
        }

        &.active {
          box-shadow: 0 4px 8px -3px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(0, 0, 0, 0.08);
          background-color: #ffffff;
          color: #222222;
        }
      }
    }

    .score {
      display: inline-block;
      margin: 0 0 0 3px;
      padding: 1px 8px;
      border-radius: 4px;
      box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.15);
      background-color: #3eaa08;
      color: #ffffff;
      font-size: 14px;
      position: relative;
      top: -1px;
      font-weight: bold;
      text-transform: capitalize;

      &.pass {
        background-color: #3eaa08;
      }

      &.fail {
        background-color: #ec0047;
      }
    }

    .jira {
      position: relative;
      margin: 0 -4px 0 3px;

      .tooltip {
        transform-origin: top;
        position: absolute;
        top: 30px;
        left: 50%;
        transform: translate(-50%, -10px) scaleY(0.2);
        background: #ffffff;
        text-align: left;
        opacity: 0;
        transition: transform 0.2s ease,
                    opacity 0.2s ease;
        font-weight: normal;
        border-radius: 6px;
        white-space: nowrap;
        box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
        padding: 13px 15px 14px;
        color: #444444 !important;
        font-size: 13px;
        line-height: 1;
        z-index: 10000;
        cursor: default;

        strong {
          display: block;
          margin-bottom: 2px;
          height: auto;
        }

        a {
          display: block;
          margin-top: 2px;
          padding: 0;
          color: #0f4db5;
          height: auto;
        }

        &::after {
          content: '';
          background-color: #fff;
          position: absolute;
          z-index: 2;
          transform: rotate(-45deg);
          width: 8px;
          height: 8px;
          box-shadow: 1px -1px 0 0 rgba(0, 0, 0, 0.16);
          left: calc(50% - 6px);
          top: -4px;
        }
      }

      &:hover {
        .tooltip {
          transform: translate(-50%, 0);
          opacity: 1;
        }
      }
    }

    .score-all {
      margin-left: 3px;

      .jira {
        .tooltip {
          margin-left: 2px;
        }
      }
    }
  }

  .report-info {
    margin: 11px 14px 0 10px;
    display: flex;

    .title {
      flex-grow: 1;
      padding: 0 20px 0 5px;

      h2 {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 600;
        font-size: 24px;
        color: #222222;
        margin-bottom: -3px;

        .diagnosis-type {
          display: inline-block;
          vertical-align: middle;
          margin: 0 5px 5px 0;
          padding: 5px;
          border-radius: 5px;
          border: solid 1px #d9c8a7;
          background-color: #ffffff;
          font-size: 16px;
          font-weight: bold;
          line-height: 1;
          color: #666666;
          text-transform: capitalize;
        }
      }

      .type {
        font-size: 14px;
        line-height: 1;
        color: #444444;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .report-type {
          padding: 0 3px 0 4px;
          border-radius: 3px;
          border: solid 1px #c1c1c1;
          background-color: #ffffff;
          font-size: 11px;
          color: #767676;
          display: inline-block;
          vertical-align: middle;
          margin-right: 5px;
        }
      }
    }

    .more-info {
      flex-basis: 400px;
      flex-grow: 0;
      text-align: right;
      font-size: 13px;
      line-height: 1;
      letter-spacing: normal;
      text-align: right;
      color: #444444;
      white-space: nowrap;

      p {
        margin: 8px 0;

        em {
          color: #ec0047;
        }

        .bar {
          display: inline-block;
          width: 1px;
          height: 11px;
          background-color: #d7d7d7;
          margin: 0 12px;
          vertical-align: middle;
        }
      }

      button {
        line-height: 1;
        text-align: center;
        color: #444444;
        padding: 2px 4px;
        border-radius: 3px;
        margin-left: 2px;
        border: solid 1px #bbbbbb;
        color: #999999;
        background-color: #ffffff;
      }
    }

    .more-layer {
      table {
        margin-bottom: 40px;

        th,
        td {
          line-height: 1.3;
          vertical-align: top;

          p {
            padding-top: 0;
            margin: 5px 0;
          }
        }

        th {
          width: 200px;
        }

        td {
          min-width: 200px;
        }
      }
    }

    .buttons {
      height: 42px;
      margin-right: -4px;
      padding-top: 13px;

      &::before {
        content: "";
        display: inline-block;
        vertical-align: middle;
        width: 1px;
        height: 20px;
        background-color: #d1d1d0;
        margin: 0 8px 0 15px;
      }

      button {
        vertical-align: middle;
        font-size: 13px;
        font-weight: 500;
        line-height: 1;
        text-align: center;
        color: #444444;
        padding: 10px 18px 9px 19px;
        border-radius: 6px;
        min-width: 85px;
        margin-left: 3px;

        .icon--share {
          height: 13px;
          background-size: 16px 16px;
          width: 13px;
          margin: -2px 5px 0 -5px;
        }

        &.btn1 {
          border: solid 1px #ec0047;
          background-color: #ec0047;
          color: #ffffff;
        }

        &.btn2 {
          border: solid 1px #ec0047;
          background-color: #ffffff;
          color: #ec0047;
          padding: 10px 10px 9px 0;

          span {
            display: inline-block;
            background: #f0f0f0;
            border-radius: 4px;
            padding: 3px 5px;
            color: #444444;
            box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.15);
            margin: -5px 5px -5px;
            font-size: 12px;

            .icon {
              margin: -3px 0 -1px;
              width: 14px;
              height: 14px;
              background-color: transparent;
            }
          }
        }

        &.btn3 {
          border: solid 1px #bbbbbb;
          background-color: #ffffff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/report/ReportInfo.vue